<template lang="pug">
#Marketplace
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Marketplace" :HeaderGlobalBreadcrumb="breadcrumb")
    .box
        .box__header.no-border
            header.flex.items-center.justify-between
                .header-meta
                    h2.subheading Tokopedia
                .header-cta.flex.items-center(v-if="tokped && Object.keys(tokped).length > 0")
                    //- router-link.link-text(to="#") Visit account

        .box__body.p-4
            template(v-if="load_data_status_tokped.status === 'loading'")
                Loading(show="true")
            template(v-else-if="tokped && Object.keys(tokped).length > 0")
                .flex.flex-wrap.-mx-4
                    .block.px-4(class="w-full lg:w-4/12")
                        .block.mb-4
                            span.block.mb-1 Name
                            router-link.link-text.block(:to="tokped.data.full_name ? '/search-by-name/'+ encrypt(tokped.data.full_name,'name') : '/search-by-name'" target="_blank")
                                | {{tokped.data.full_name?tokped.data.full_name:'-'}}

                        .block.mb-4
                            span.block.mb-1 Email
                            template(v-if="tokped.data.msisdn && tokped.data.msisdn === tokped.data.user_email") - 
                            template(v-else-if="type === 'email'") {{tokped.data.user_email}} 
                            router-link.link-text.block(
                                v-else
                                :to="'/result/'+ encrypt(tokped.data.user_email,'email') +'/marketplace'"
                                ) {{tokped.data.user_email?tokped.data.user_email:'-'}}

                        .block.mb-4
                            span.block.mb-1 MSISDN
                            template(v-if="type === 'msisdn'") {{tokped.data.msisdn}} 
                            router-link.link-text.block(
                                v-else-if="tokped.data.msisdn"
                                :to="'/result/'+ encrypt(tokped.data.msisdn,'msisdn') +'/recent-location'"
                                ) {{tokped.data.msisdn?tokped.data.msisdn:'-'}}
                            span(v-else) -

                        .block.mb-4
                            span.block.mb-1 Birthday
                            h3.text-light.monospace  {{tokped.data.sex}}, {{tokped.data.birth_date?datetimeFormat(tokped.data.birth_date,"DD MMM YYYY"):'-'}}

                    .block.px-4(class="w-full lg:w-4/12")
                        .block.mb-4
                            span.block.mb-1 Address
                            h3.text-light.monospace {{tokped.data.location?tokped.data.location:'-'}}
                        .block.mb-4
                            span.block.mb-1 Create Time
                            h3.text-light.monospace {{tokped.data.create_time?datetimeFormat(tokped.data.create_time):'-'}}
            NoDataAvailable(v-else)
    //- end
    //- .box
        .box__header.no-border
            header.flex.items-center.justify-between
                .header-meta
                    h2.subheading Shopee
                .header-cta.flex.items-center
                    router-link.link-text(to="#") Visit account

        .box__body.p-4
            .flex.flex-wrap.-mx-4
                .block.px-4(class="w-full lg:w-4/12")
                    .block.mb-4
                        span.block.mb-1 Name
                        router-link.link-text.block(to="#") SOFYAN SYAHRUL IKHSAN

                    .block.mb-4
                        span.block.mb-1 Email
                        router-link.link-text.block(to="#") email@mail.com

                    .block.mb-4
                        span.block.mb-1 MSISDN
                        router-link.link-text.block(to="#") 0987654321

                    .block.mb-4
                        span.block.mb-1 Birthday
                        h3.text-light.monospace Male, 20 Sept 1992 (28)

                .block.px-4(class="w-full lg:w-4/12")
                    .block.mb-4
                        span.block.mb-1 Address
                        h3.text-light.monospace Dagaran uh6/1066, Gang belimbing masuk ketimur, Jl. Pakel Baru, Sorosutan, Kec. Umbulharjo, Kota Yogyakarta, Daerah Istimewa Yogyakarta 55162
    //- end

</template>

<script>
import HeaderGlobal from '@/components/HeaderGlobal.vue';
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import moment from 'moment';
import { encrypt, decrypt } from '@/util/crypto';

export default {
    name: 'Marketplace',
    components: {
        HeaderGlobal,
        Loading,
        NoDataAvailable,
    },
    props: ['resultGlobalBreadcrumb'],
    data() {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Marketplace',
                    url: '/result/marketplace',
                },
            ],
        };
    },
    computed: {
        ...mapState([
            'load_data_status_tokped',
            'tokped',
        ]),
        key() {
            return this.$route.params.key;
        },
        type(){
            let decrypt_data = decrypt(this.key);
            decrypt_data = decrypt_data.split('&&');

            return decrypt_data[1];
        }
    },
    watch: {
        // 
    },
    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        },
        datetimeFormat(datetime, format="DD MMM YYYY HH:mm:ss") {
            return moment(datetime, 'YYYY-MM-DDThh:mm:ssZ').format(format);
        },
        encrypt(key, type) {
            return encrypt(key+ '&&' +type);
        },
    },
    mounted() {
    },
}
</script>

<style lang="sass">
</style>
